import { timesheetsDashboardState, timesheetsState, timesheetsDeclarationState, timesheetsOverviewState } from './timesheets.states';
import { timesheetsComponent } from './timesheets.component';
import { timesheetsDashboardComponent } from './timesheets.dashboard.component';
import { loadNg1Module, ngmodule } from "../../bootstrap/ngmodule";
import { timesheetDetailsComponent } from "./timesheetDetails.component";
import { declarationComponent } from "./declaration.component";
import { timesheetsOverviewComponent } from "./timesheetsOverview.component";
import { timesheetsSummaryComponent } from './timesheetsSummary.component';
const quotationsAppModule: aboTheme.INgModule = {
    components: { timesheetsComponent, timesheetsDashboardComponent, timesheetDetailsComponent,
                declarationComponent, timesheetsOverviewComponent, timesheetsSummaryComponent },
    states: [ timesheetsState, timesheetsDashboardState, timesheetsDeclarationState,
              timesheetsOverviewState ],
};

loadNg1Module(ngmodule, quotationsAppModule);



// WEBPACK FOOTER //
// ./src/app/modules/timesheets/index.ts